export const IMS_UNLIMITED_AMOUNT = '9223372036854775807';

export const UNLIMITED_AMOUNT = Number(IMS_UNLIMITED_AMOUNT);
